<h1 color=primary mat-dialog-title>Error with adding new user in Datatrac</h1>
<div mat-dialog-content>
There was an issue with adding the new user in Datatrac: {{data}}
</div>
<br>
<div mat-dialog-actions>
  <button color=primary mat-raised-button (click)="close()">
    Close
  </button>
</div>